import { Accordion } from '../../../../../components/general/accordion';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import { Table } from '../../../../../components/general/table';
import { usePqrStatusHistory } from './hook';
import { PqrStatusHistoryProps } from './props';

export const PqrStatusHistory = (props: PqrStatusHistoryProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        usePqrStatusHistory(props);

    return (
        <Accordion
            title="HISTÓRICO ESTADOS"
            icon={<FolderCopyIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Table
                columns={columns}
                rows={rows}
                rowCount={total}
                loading={loading}
                paginationModel={{
                    page,
                    pageSize,
                }}
                onPaginationModelChange={paginator}
                pageSizeOptions={[2, 10, 20, 50]}
                disableRowSelectionOnClick
            />
        </Accordion>
    );
};
